import { useContext } from "react";
import { Link } from "react-router-dom";

import { Stack } from "@mui/material";

import { logo } from "../utils/constants";
import SearchBar from "./SearchBar";
import ThemeSwitch from "./ThemeSwitch";
import { ThemeContext } from "../ThemeContext";

const Navbar = () => {

  const { darkMode } = useContext(ThemeContext)

  return (
    <Stack
      direction="row"
      alignItems="center"
      p={2}
      sx={{
        position: "sticky",
        // backgorund: "#000",
        background: darkMode === true ? "#000" : "#fff",
        top: 0,
        justifyContent: "space-between",
      }}
    >
      <Link to="/" style={{ display: "flex", alignItems: "center" }}>
        <img src={logo} alt="logo" height={45} />
      </Link>
      <ThemeSwitch/>

      <SearchBar/>
    </Stack>
  );
};

export default Navbar;
